var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.695,
    height: 17,
    viewBox: "0 0 18.695 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chat_bubble_FILL0_wght300_GRAD0_opsz24",
    d: "M103.483-845.24l-1.97,1.97a.815.815,0,0,1-.966.19.829.829,0,0,1-.546-.828V-858.22a1.717,1.717,0,0,1,.517-1.262A1.717,1.717,0,0,1,101.78-860h15.137a1.717,1.717,0,0,1,1.262.517,1.717,1.717,0,0,1,.517,1.262v11.2a1.717,1.717,0,0,1-.517,1.262,1.717,1.717,0,0,1-1.262.517Zm-.628-1.476h14.062a.29.29,0,0,0,.208-.095.29.29,0,0,0,.095-.208v-11.2a.289.289,0,0,0-.095-.208.29.29,0,0,0-.208-.095H101.78a.289.289,0,0,0-.208.095.289.289,0,0,0-.095.208v12.867Zm-1.378,0v0Z",
    transform: "translate(-100.001 859.999)",
    fill: "#072635"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMessages);
export default __webpack_public_path__ + "static/media/ic_messages.d19000e7b1297adb19ca6baf1d700a9e.svg";
export { ForwardRef as ReactComponent };